// removed by extract-text-webpack-plugin
module.exports = {"DiceHolder":"Dice__DiceHolder__2FcCp","Dice":"Dice__Dice__32A65","Active":"Dice__Active__2VHuZ","rotate":"Dice__rotate__2d6WS","Front":"Dice__Front__3LZ7m","Back":"Dice__Back__16AQs","Right":"Dice__Right__2D9f5","Left":"Dice__Left__12ZU4","Top":"Dice__Top__1x9iD","Bottom":"Dice__Bottom__wt2jI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Dice/Dice.css
// module id = 91
// module chunks = 0